// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__tHTJm","aboutNavigation":"Header_aboutNavigation__cx_VJ"};